import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import Badge from 'ui/components/badge/'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import useStyles from './styles'
import { ReactComponent as IconBookmark } from 'assets/icons/bookmark.svg'
import { ReactComponent as IconDocument } from 'assets/icons/document.svg'
import { ReactComponent as IconBookmarkStar } from 'assets/icons/bookmark-star.svg'
import useTranslation from 'hooks/useTranslations'

const DocumentCard = props => {
  const { variant, infoText, contentText, status } = props

  const classes = useStyles()

  const t = useTranslation()

  let icon
  const chooseIcon = iconName => {
    icon = <SvgIcon component={iconName} className={classes.icon} />
  }
  if (variant === 1) {
    chooseIcon(IconBookmark)
  } else if (variant === 2) {
    chooseIcon(IconDocument)
  } else if (variant === 3) {
    chooseIcon(IconBookmarkStar)
  }

  let badge
  const chooseBadge = text => {
    badge = <Badge type={status} label={text} />
  }

  if (status === 'validated') {
    chooseBadge(t('badge:validated'))
  } else if (status === 'attached') {
    chooseBadge(t('badge:attached'))
  } else if (status === 'pending') {
    chooseBadge(t('badge:pending'))
  } else if (status === 'expired') {
    chooseBadge(t('badge:expired'))
  } else if (status === 'rejected') {
    chooseBadge(t('badge:rejected'))
  }

  return (
    <Card className={classes.root} elevation={1}>
      <Box
        className={clsx(
          classes.iconWrapper,
          variant === 1 && classes.iconWrapperCertification,
          variant === 2 && classes.iconWrapperMandatoryDocumentation,
          variant === 3 && classes.iconWrapperSpecificDocumentation,
        )}
      >
        {icon}
      </Box>
      <Box className={classes.content}>
        <Box className={classes.textsWrapper}>
          <Typography
            variant="subtitle1"
            component="p"
            className={classes.infoText}
          >
            {infoText}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            className={classes.contentText}
          >
            {contentText}
          </Typography>
        </Box>
        {status ? <Box className={classes.badgeWrapper}>{badge}</Box> : null}
      </Box>
    </Card>
  )
}

DocumentCard.propTypes = {
  variant: PropTypes.number,
  infoText: PropTypes.string,
  contentText: PropTypes.string,
  status: PropTypes.string,
}

export default DocumentCard
